import { useState, useContext } from 'react'
import { ModalContext, ModalKey } from '../Modals/ModalContext'
import { WorkoutTemplateBuilderContext } from './WorkoutTemplateBuilder'
import {
    ChevronUpIcon,
    ChevronDownIcon,
    ArrowPathIcon,
    MagnifyingGlassPlusIcon,
    EyeSlashIcon,
    ArrowsPointingOutIcon,
    ArrowsPointingInIcon,
    DocumentDuplicateIcon,
    TrashIcon,
} from '@heroicons/react/24/outline'

import PhaseNameInputBox from './InputBoxes/PhaseNameInputBox'
import FloatingMenuEllipsisButton from './Buttons/FloatingMenuEllipsisButton'

import PhaseNoteInputBox from './InputBoxes/PhaseNoteInputBox'

import CircuitRoundsButton from './Buttons/Phase/CircuitRoundsButton'

import ExerciseCard from './Cards/ExerciseCard'

export default function WorkoutPhase({ phase, phaseIndex }) {
    const { ShowModal } = useContext(ModalContext)
    const { mutatePhase, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    const [showRest, setShowRest] = useState(false)

    const phaseSettings = [
        {
            color: 'gray',
            icon: ChevronUpIcon,
            text: 'Move Phase Up',
            action: () => mutatePhase('position-up', phaseIndex),
        },
        {
            color: 'gray',
            icon: ChevronDownIcon,
            text: 'Move Phase Down',
            action: () => mutatePhase('position-down', phaseIndex),
        },
        {
            color: 'gray',
            icon: ArrowPathIcon,
            text: 'Switch to ' + (phase.type === 'straight' ? 'circuit' : 'straight') + ' type',
            action: () => mutatePhase('change-phase-type', phaseIndex, phase.type === 'straight' ? 'circuit' : 'straight'),
        },
        {
            color: 'gray',
            icon: MagnifyingGlassPlusIcon,
            text: 'Add Exercise',
            action: () => ShowAddExerciseModal(),
        },
        {
            color: 'gray',
            icon: EyeSlashIcon,
            text: 'Toggle Rest',
            action: () => setShowRest(!showRest),
        },
        {
            color: 'gray',
            icon: ArrowsPointingOutIcon,
            text: 'Expand All Exercises',
            action: () => mutatePhase('expand-all', phaseIndex),
        },
        {
            color: 'gray',
            icon: ArrowsPointingInIcon,
            text: 'Collapse All Exercises',
            action: () => mutatePhase('collapse-all', phaseIndex),
        },
        {
            color: 'gray',
            icon: DocumentDuplicateIcon,
            text: 'Duplicate Phase',
            action: () => mutatePhase('duplicate-phase', phaseIndex),
        },
        {
            color: 'red',
            icon: TrashIcon,
            text: 'Delete Phase',
            action: () => ShowDeletePhaseModal(),
        },
    ]

    // Show Delete Phase Modal
    const ShowDeletePhaseModal = () => {
        const modalData = {
            key: ModalKey.ActionWarning,
            size: 'half',
            titleText: 'Delete this workout phase?',
            bodyText: ['Are you sure you want to delete this phase? Phase exercises will also be deleted'],
            buttonText: 'Delete',
            buttonAction: () => mutatePhase('delete-phase', phaseIndex),
        }

        ShowModal(modalData)
    }

    // Show Add Exercise Modal
    const ShowAddExerciseModal = () => {
        const modalData = {
            key: ModalKey.SelectExercise,
            titleText: 'Select An Exercise',
            size: 'half',
            buttonAction: (exercise) => mutateExercise('add-exercise', phaseIndex, null, null, exercise),
        }

        ShowModal(modalData)
    }

    return (
        <div className="border border-stone-400 rounded-lg">
            {/* Phase Header */}
            <div className="flex items-center">
                {/* Phase Name */}
                <PhaseNameInputBox phase={phase} phaseIndex={phaseIndex} />

                {/* Circuit Rounds */}
                <CircuitRoundsButton phase={phase} phaseIndex={phaseIndex} />

                {/* Phase Settings Menu */}
                <FloatingMenuEllipsisButton settings={phaseSettings} />
            </div>

            {/* Phase Note */}
            <PhaseNoteInputBox phase={phase} phaseIndex={phaseIndex} />

            {/* Exercises */}
            {phase.exercises.map((exercise, exerciseIndex) => (
                <div key={exerciseIndex}>
                    <ExerciseCard phase={phase} phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} showRest={showRest} />
                </div>
            ))}
        </div>
    )
}
